import { render, staticRenderFns } from "./GaleriaView.vue?vue&type=template&id=48a9a5b2"
import script from "./GaleriaView.vue?vue&type=script&lang=ts"
export * from "./GaleriaView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports